// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/play-filled.svg';

export const PlayFilled = (props: SvgIconProps) => {
    return <SvgIcon component={Svg} inheritViewBox {...props} />;
};
